export default `
  @font-face {
    font-family: 'Urbanist';
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/Urbanist/Urbanist-Regular.woff2') format('woff2'),
         url('/fonts/Urbanist/Urbanist-Regular.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Urbanist';
    font-weight: 600;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/Urbanist/Urbanist-SemiBold.woff2') format('woff2'),
         url('/fonts/Urbanist/Urbanist-SemiBold.ttf') format('truetype');
  }

  @font-face {
    font-family: 'Urbanist';
    font-weight: 700;
    font-style: normal;
    font-display: swap;
    src: url('/fonts/Urbanist/Urbanist-Bold.woff2') format('woff2'),
         url('/fonts/Urbanist/Urbanist-Bold.ttf') format('truetype');
  }
`;
